import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function EmptyState({
  icon: Icon,
  title,
  body,
  action,
  className,
  compact = false,
}: {
  icon: LucideIcon;
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  className?: string;
  compact?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-xl border border-dashed border-border text-center",
        compact ? "gap-2 px-4 py-8" : "gap-3 px-6 py-14",
        className,
      )}
    >
      <div className="relative">
        <div className="absolute inset-0 -z-10 scale-150 rounded-full bg-brand/10 blur-xl" />
        <div className="flex size-11 items-center justify-center rounded-xl border border-border bg-surface shadow-sm">
          <Icon className="size-5 text-muted-foreground" />
        </div>
      </div>
      <div className="max-w-sm">
        <p className="font-medium">{title}</p>
        {body ? <p className="mt-1 text-sm text-pretty text-muted-foreground">{body}</p> : null}
      </div>
      {action ? <div className="mt-1 flex flex-wrap justify-center gap-2">{action}</div> : null}
    </div>
  );
}
